import { Component, OnInit } from '@angular/core';
import { GetOrdersService } from 'src/app/services/get-orders.service';
import { ViewTablesNos } from 'src/app/interfaces/view-tables-nos';
import { AngularFirestore, AngularFirestoreDocument, AngularFirestoreCollection } from '@angular/fire/firestore';
import { Observable } from 'rxjs';
import { Order } from 'src/app/interfaces/order.interface';
import { Total } from 'src/app/interfaces/total.interface';
import { NgForm } from '@angular/forms';
import { OrderSubInfo } from 'src/app/interfaces/order-sub-info';
import { Totalssum } from 'src/app/interfaces/totalssum';
import { ArrayType } from '@angular/compiler';
import { Price } from 'src/app/interfaces/price';
import { Amount } from 'src/app/interfaces/amount';
import { Confirmed } from 'src/app/interfaces/confirmed';
import { TransferService } from 'src/app/services/transfer.service';
import { CartService } from 'src/app/services/cart.service';
import { FilterdObj } from 'src/app/interfaces/filterd-obj';
import { AuthService } from 'src/app/services/auth.service';

@Component({
  selector: 'app-orders-panel',
  templateUrl: './orders-panel.component.html',
  styleUrls: ['./orders-panel.component.scss']
})



export class OrdersPanelComponent implements OnInit {

  views: ViewTablesNos[] = []

  orders: Order[] = []

  subInfo: OrderSubInfo[] = []

  constructor(private getOrders: GetOrdersService , private fs: AngularFirestore, private Order:CartService, private aus: AuthService) { }

  linkRef: AngularFirestoreCollection<any>;

  linkRef2: AngularFirestoreDocument<any>;

  link: Observable<any>;

  total: Total[] = []

  subtotal: number = null;

  confirmedd: Confirmed[] = []

  ordersLength: number = null;

  ordersSubInfoLength: number = null;

  sum:boolean=false;

  filtered: FilterdObj[] = []

  albasaten :string='البساتين'

  alyaqot :string='الياقوت'
  
  al3alia: string="العليا" 
  
  ngOnInit(): void {
    
    this.getOrders.getOrders().subscribe(data => { 
      
      this.views = data.map(element => {
        return {
          id:element.payload.doc.id,
          ...element.payload.doc.data() as {},
        }  
      })

      this.aus.user.subscribe(user => {
        
        console.log("user Email:", user.email)

        if(user.email == "controlpanel2020@admin.com") {
        
          this.filtered = this.views
        
        }
        
        if(user.email == "albasatencontrolpanal2020@admin.com"){
                
          console.log('data',data, this.views)
          
          this.filtered = this.views.filter(view => view.brunch === this.albasaten)
          
          console.log('filterd',this.filtered)  
        
        }
      
        if(user.email == "alyaqotcontrolpanal2020@admin.com"){
                
          console.log('data',data, this.views)
          
          this.filtered = this.views.filter(view => view.brunch === this.alyaqot)
          
          console.log('filterd',this.filtered)  
        
        }

        if(user.email == "al3aliacontrolpanal2020@admin.com"){
                
          console.log('data',data, this.views)
          
          this.filtered = this.views.filter(view => view.brunch === this.al3alia)
          
          console.log('filterd',this.filtered)  
        
        }

      })
   
   })

}

  getorders(id) {
    this.linkRef = this.fs.collection(`users/${id}/order`)
    this.link = this.linkRef.snapshotChanges();
    this.link.subscribe(data=> {
        this.orders = data.map(element => {
          return {
            id:element.payload.doc.id,
            ...element.payload.doc.data() as {},
          }
        })
        this.ordersLength = data.length;
    })
    setTimeout(()=>{
      this.sum = true;
      }, 1000);
      setTimeout(()=>{
        this.sum = false;
      }, this.ordersLength*1000);
      setTimeout(()=>{
        this.susm()
      },4000)
  }

  lx:Array<number> = []
 
  totalll:number = null

  tax:number = null

  all:number = null

 recieve(x:number) {
          
          this.lx.push(x);
    }
  susm() { 
          this.lx.length = this.ordersLength;

          let v = this.lx.reduce( (accumulator, currentValue) => accumulator + currentValue )

          this.totalll = v;

          console.log(this.totalll, ':التكلفة الكاملة')

          this.tax = this.totalll * 0.15

          console.log(this.tax, ':الضريبة المضافة')

          this.all = this.tax + this.totalll

        }

  delete(index, id) {
       this.Order.deleteFromPanel(id,this.orders[index].id)
       .then (()=> {
        document.getElementById('done').style.display="block";
        setTimeout(()=>{
          document.getElementById('done').style.display="none";
        }, 3000);
       })
  }

  getsub(id) {
    this.linkRef = this.fs.collection(`users/${id}/ordersubinfo`)
    this.link = this.linkRef.snapshotChanges();
    this.link.subscribe(data=> {
      this.subInfo = data.map(element => {
        return {
          id:element.payload.doc.id,
          ...element.payload.doc.data() as {},
        }
      })
      this.ordersSubInfoLength = data.length;
    })    
  }

  deletesub(index,id) {
    this.Order.deleteSubFromPanel(id,this.subInfo[index].id)
    .then (()=> {
      document.getElementById('done2').style.display="block";
      setTimeout(()=>{
        document.getElementById('done2').style.display="none";
      }, 3000);
     })
  }

  changeGstauts(id) {
    this.linkRef2 = this.fs.doc(`users/${id}`)
     this.linkRef2.update({
      gstatus:false 
     })
  }

  deleteUser(id) {
    this.Order.deleteUser(id)    
  }

}
